import css from '@styled-system/css'
import { ReactElement, ReactNode, useCallback } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import {
  border,
  BorderProps,
  compose,
  layout,
  LayoutProps,
  space,
  SpaceProps,
  variant,
} from 'styled-system'

import { FlexAnchor, mdBumps } from '../atoms'

export interface SelectResultProps<T> extends BorderProps {
  children?: ReactNode
  onClickParams: T
  onClick: (params: T) => void
}

export type SelectResultsProperty = 'default'

export interface SelectResultsProps extends LayoutProps, SpaceProps, BorderProps {
  variant?: SelectResultsProperty
}

export const SelectResult = <T,>({
  children,
  onClick,
  onClickParams,
  ...props
}: SelectResultProps<T>): ReactElement => {
  const onLinkClick = useCallback(
    () => onClick?.(onClickParams),
    [onClick, onClickParams],
  )

  return (
    <FlexAnchor
      data-testid='select-result'
      as='li'
      variant='inset'
      px={mdBumps}
      py={3}
      width={1}
      onClick={onLinkClick}
      {...props}
    >
      {children}
    </FlexAnchor>
  )
}

export const SelectResults = styled.ul<SelectResultsProps>(
  css({
    width: '100%',
    overflowY: 'auto',
    top: '100%',
    borderRadius: 2,
    maxHeight: '14rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    py: 2,
    zIndex: 150,
    fontFamily: 'input',
  }),
  variant({
    scale: 'SelectResults',
    variants: {
      default: {},
    },
  }),
  compose(layout, space, border),
)

SelectResults.defaultProps = {
  variant: 'default',
}
